import { render } from "./ListaPostagensPublicas.vue?vue&type=template&id=507ffe67&scoped=true"
import script from "./ListaPostagensPublicas.vue?vue&type=script&lang=js"
export * from "./ListaPostagensPublicas.vue?vue&type=script&lang=js"

import "./ListaPostagensPublicas.vue?vue&type=style&index=0&id=507ffe67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507ffe67"]])

export default __exports__